import { auth } from '@/lib/firebase'

/**
 * Ported from taptalent-account-management-frontend/src/lib/auth-token.ts
 *
 * Note what this deliberately is NOT: the older ClientSide_TapTalent app propagates the
 * token by mutating a shared module-level `BASE_HEADERS` object, so every call site has to
 * remember to refresh it. Here the axios request interceptor calls this, once, per request.
 */
export async function getFirebaseIdToken(forceRefresh = false): Promise<string | null> {
  await auth.authStateReady()
  const user = auth.currentUser
  if (!user) return null
  return user.getIdToken(forceRefresh)
}
